// extracted by mini-css-extract-plugin
export default {"icon":"Error_icon__C+jko"};